import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import contactImage from "../../components/images/contact-image.jpg";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2"; // Import SweetAlert2 (Swal)
import emailjs from "emailjs-com";


const Item = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const ContactForm = () => (
  <Formik
    initialValues={{
      name: "",
      email: "",
      phone: "",
      description: "",
    }}
    validationSchema={Yup.object({
      name: Yup.string().required("Name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      phone: Yup.string()
        .matches(/^(?!0)\d{10}$/, {
          message:
            "Phone number must be exactly 10 digits and should not start with 0",
          excludeEmptyString: true,
        })
        .required("Phone number is required"),
      description: Yup.string().required("Required"),
    })}
    onSubmit={(values, { setSubmitting, resetForm }) => {
      emailjs
        .send(
          "service_n1j39f7",
          "template_wspim8h",
          values,
          "39tMIbOjESzWXi_fI"
        )
        .then((response) => {
          if (response.status === 200) {
            Swal.fire({
              title: "Success!",
              text: "Your message has been sent.",
              icon: "success",
              confirmButtonText: "Ok",
            });
            resetForm();
          } else {
            throw new Error("Failed to send message");
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "Error!",
            text: "An error occurred while sending your message.",
            icon: "error",
            confirmButtonText: "Ok",
          });
        })
        .finally(() => {
          setSubmitting(false);
        });
    }}
  >
    {({
      values,
      errors,
      touched,
      handleChange,
      handleBlur,
      handleSubmit,
      isSubmitting,
    }) => (
      <Form>
        <Box sx={{ flexGrow: 1, p: 0, marginTop: "30px" }}>
          <Grid container spacing={1} columns={12}>
            <Grid item xs={12} sm={6}>
              <Card>
                <CardContent
                  sx={{
                    height: "500px",
                    backgroundImage: `url(${contactImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
              </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Card>
                <CardContent
                  sx={{
                    height: "500px",
                    paddingTop: "0px",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <h3 className="mt-4">Contact Us</h3>
                  <Field
                    as={TextField}
                    id="name"
                    name="name"
                    label="Name"
                    variant="outlined"
                    margin="normal"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.name && Boolean(errors.name)}
                    helperText={touched.name && errors.name}
                    size="small"
                    margin="dense"
                  />
                  <Field
                    as={TextField}
                    id="email"
                    name="email"
                    type="email"
                    label="Email"
                    variant="outlined"
                    margin="normal"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                    size="small"
                    margin="dense"
                  />
                  <Field
                    as={TextField}
                    id="phone"
                    name="phone"
                    label="Phone Number"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    value={values.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.phone && Boolean(errors.phone)}
                    helperText={touched.phone && errors.phone}
                    size="small"
                    margin="dense"
                  />
                  <Field
                    as={TextField}
                    id="description"
                    name="description"
                    label="Description"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    multiline
                    rows={2}
                    value={values.description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.description && Boolean(errors.description)}
                    helperText={touched.description && errors.description}
                    size="small"
                    margin="dense"
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={isSubmitting}
                    sx={{ m: 0, width: "100%" }}
                  >
                    {isSubmitting ? "Submitting..." : "Send"}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Form>
    )}
  </Formik>
);

export default ContactForm;
